"use client";

export function isBrowser(): boolean {
  return typeof window !== "undefined";
}
